import * as Yup from 'yup';
import errorMessages from 'constants/errorMessages';

export const getValidationSchema = () => {
  const shape = {
    name: Yup.string().required(errorMessages.basicRequired),
    definition: Yup.string().nullable(),
    procedural_definition: Yup.string().nullable(),
  };

  return Yup.object().shape(shape);
};
